/**
* @file 业务管理-包车提成规则
* */
<template>
  <div id="commission">
    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns" 
    max-height="450"
       addText="创建规则" @addFn="addFn">
      <div slot="search-top-left" class="util-remark">
        注：如果未开启任何提成规则，司机完成订单后，将收不到提成金额
      </div>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="100px">
          <div slot-scope="{ row }" class="custom-action">
            <el-tooltip content="查看" placement="top">
              <i class="el-icon-view" @click="viewClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click="removeClick(row)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'proportion'">
          {{ row.type == 1 ? "比例提成" : "阶梯提成" }}
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!--创建提成规则弹框-->
    <el-dialog title="创建提成规则" :visible.sync="visible" width="900px" :close-on-click-modal="false">
      <p style="font-size: 14px; color: #ccc">
        * 假设提成比例为10%，则司机每笔班次的收入提成10%
      </p>
      <p style="font-size: 14px; margin: 6px 0 10px 0; color: #ccc">
        * 以订单金额进行核算，例如：订单金额￥100，优惠券折扣￥10，实付金额￥90，将按￥100核算提成
      </p>
      <el-form :model="form" :rules="rules" ref="form" label-width="80px" label-position="left">
        <el-form-item label="提成方式">
          <el-radio v-model="radio" label="1">比例提成</el-radio>
          <el-radio v-model="radio" label="2">阶梯提成</el-radio>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="form.name" maxlength="18"></el-input>
        </el-form-item>

        <el-form-item label="机构名称" prop="organizationId">
          <el-select v-model="form.organizationId" filterable
            v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{
            organizations && organizations[0] && organizations[0].name
          }}</span>
        </el-form-item>

        <el-form-item v-if="radio == 1" label="提成比例" prop="proportion">
          <el-input v-model="form.proportion">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <p v-if="radio == 2" style="font-size: 14px; margin: 6px 0 10px 0; color: #ccc">
          注意：如设为定额提成，当实付金额 ＜ 提成金额时，不会进行抽成核算
        </p>

        <div class="commissions" v-if="radio == 2">
          <div class="commis" v-for="(item, index) in form.selects" :key="index">
            <span style="margin-right: 6px">当实付金额为</span>
            <el-input disabled style="width: 80px" v-model="item.minFee">
              <template slot="suffix">元</template></el-input>
            <span style="margin: 0 6px 0 6px">至</span>

            <el-form-item label="" :prop="'selects.' + index + '.maxFee'" :rules="[
              { required: true, message: '请输入正确的规则' },
              {
                pattern: /^[+-]?((\d*(\.\d{1,2})$)|(\d{1,3}$))/,
                message: '请输入正确的规则',
              },
              { validator: validateChangeTimeNum, trigger: 'change' },
            ]">
              <el-input style="width: 120px" v-model="item.maxFee" :readonly="item.readonly1">
                <template slot="suffix">元</template></el-input>
            </el-form-item>

            <span style="margin: 0 6px 0 6px">提成方式为</span>

            <p class="selects">
              <el-select size="mini" v-model="item.ruleType" placeholder="请选择提成" @change="changeCheck">
                <el-option label="比例提成" value="1"></el-option>
                <el-option label="定额提成" value="2"></el-option>
              </el-select>
            </p>
            <span style="margin: 0 6px 0 10px">司机提成</span>

            <el-form-item label="" :prop="'selects.' + index + '.ruleNum'" :rules="
              item.ruleType == 1
                ? [
                  { required: true, message: '请输入正确的规则' },
                  {
                    pattern: /^[+-]?((\d*(\.\d{1,2})$)|(\d{1,3}$))/,
                    message: '请输入正确的规则',
                  },
                  { validator: validateChangeTimeNums, trigger: 'change' },
                ]
                : [
                  { required: true, message: '请输入正确的规则' },
                  {
                    pattern: /^[+-]?((\d*(\.\d{1,2})$)|(\d{1,3}$))/,
                    message: '请输入正确的规则',
                  },
                  { validator: validateChangeTimeNums1, trigger: 'change' },
                ]
            ">
              <el-input style="width: 120px" v-model="item.ruleNum">
                <template slot="suffix">{{
                  item.ruleType == 1 ? "％" : "元"
                }}</template>
              </el-input>
            </el-form-item>
          </div>

          <el-button type="text" v-if="form.selects.length > 1" @click="deleteList" class="testlist">删除</el-button>
        </div>
      </el-form>
      <div v-if="radio == 2 && form.selects.length < 8" class="add" @click="addClicks">
        <i class="el-icon-plus"></i>添加阶梯规则
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveClick" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>

    <!--查看提成规则弹框-->
    <el-dialog title="查看提成比例" :visible.sync="visible1" width="900px" :close-on-click-modal="false">
      <el-form disabled :model="formView" label-width="80px" label-position="left">
        <p style="font-size: 14px; color: #ccc">
          * 假设提成比例为10%，则司机每笔班次的收入提成10%
        </p>
        <p style="font-size: 14px; margin: 6px 0 10px 0; color: #ccc">
          * 以乘客实际支付金额进行提成核算，实付金额 = 应付票价 - 优惠折扣金额
        </p>
        <el-form-item label="提成方式" prop="name">
          <el-radio v-model="formView.type" label="1">比例提成</el-radio>
          <el-radio v-model="formView.type" label="2">阶梯提成</el-radio>
        </el-form-item>
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="formView.name" maxlength="18"></el-input>
        </el-form-item>

        <el-form-item label="机构名称" prop="organizationId">
          <el-input v-model="formView.organizationName" maxlength="18"></el-input>
        </el-form-item>
        <div v-show="formView.type == 1">
          <el-form-item v-if="radio == 1" label="提成比例" prop="proportion">
            <el-input v-model="formView.proportion">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </div>
        <p v-if="formView.type == 2" style="font-size: 14px; margin: 6px 0 10px 0; color: #ccc">
          注意：如设为固定提成，当实付金额 ＜ 提成金额时，不会进行抽成核算
        </p>

        <div class="commissions" v-show="formView.type == 2">
          <div class="commis" v-for="(item, index) in selects1" :key="index">
            <span style="margin-right: 6px">当实付金额为</span>

            <el-input style="width: 80px" v-model="item.minFee" maxlength="3">
              <template slot="suffix">元</template></el-input>

            <span style="margin: 0 6px 0 6px">至</span><el-input style="width: 80px" v-model="item.maxFee" maxlength="3">
              <template slot="suffix">元</template></el-input>
            <span style="margin: 0 6px 0 6px">提成方式为</span>

            <el-input style="width: 80px" :value="item.ruleType === 1 ? '比例提成' : '定额提成'"></el-input>
            <span style="margin: 0 6px 0 10px">司机提成</span>
            <el-input style="width: 80px" v-model="item.ruleNum" maxlength="3">
              <template slot="suffix">{{
                item.ruleType == 1 ? "％" : "元"
              }}</template>
            </el-input>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="visible1 = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "commission",
  data() {
    let validateProportion = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("请输入正确的数值"));
      } else if (value > 100) {
        callback(new Error("请勿大于100"));
      } else {
        callback();
      }
    };
    return {
      tishi: false,
      // 规则名称
      radio: "1",

      // 配置项
      customOptions: {
        url: "/api/v1/manage/intercity/commission/config",
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        }
      },
      // 表头
      columns: [
        { prop: "name", label: "规则名称", width: 200 },
        { prop: "proportion", label: "提成规则" },
      ],
      //
      visible: false,
      visible1: false,
      // 表单
      form: {
        proportion: null,
        fastOrderProportion: null,
        driverOrderProportion: null,
        systemOrderProportion: null,
        selects: [
          {
            minFee: "0",
            maxFee: "",
            ruleType: "1",
            ruleNum: "",
          },
        ],
      },
      formView: {},
      //提成比例
      selects: [
        {
          minFee: "0",
          maxFee: "",
          ruleType: "1",
          ruleNum: "",
        },
      ],
      selects1: [],
      // 校验规则
      rules: {
        name: [{ required: true, message: "提成比例" }],
        organizationId: [{ required: true, message: "请选择机构名称" }],
        proportion: [
          { required: true, message: "请输入提成比例" },
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
            message: "请输入正确的数值",
          },
          { validator: validateProportion },
        ],
        fastOrderProportion: [
          { required: true, message: "请输入提成比例" },
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
            message: "请输入正确的数值",
          },
          { validator: validateProportion },
        ],
        driverOrderProportion: [
          { required: true, message: "请输入提成比例" },
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
            message: "请输入正确的数值",
          },
          { validator: validateProportion },
        ],
        systemOrderProportion: [
          { required: true, message: "请输入提成比例" },
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/,
            message: "请输入正确的数值",
          },
          { validator: validateProportion },
        ],
      },
      // 保存按钮loading
      loading: false,
    };
  },
  methods: {

    /* 列表-新增 */
    async addFn() {
      this.visible = true;
      this.radio = "1";
      this.form = {
        selects: [
          {
            minFee: "0",
            maxFee: "",
            ruleType: "1",
            ruleNum: "",
          },
        ],
      };

      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      await this.mixinOrganizations();
      if (this.mixinUserInfo && this.mixinUserInfo.organizationType === 2) {
        if (
          this.organizations &&
          this.organizations[0] &&
          this.organizations[0].id
        ) {
          this.$set(this.form, "organizationId", this.organizations[0].id);
        }
      }
    },

    /* 点击保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },

    /* 接口请求-保存 */
    async postFn() {
      this.loading = true;
      let url = "/api/v1/manage/intercity/commission/config";
      let params = this.$utils.deepCopyFn(this.form);
      params.type = this.radio;
      params.commissionConfigRules = JSON.stringify(this.form.selects);
      delete params.selects;
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.visible = false;
        this.$message.success("保存成功");
        this.$refs.customTable.listFn();
      }
      this.loading = false;
    },

    /* 接口请求-删除 */
    removeClick(row) {
      let url = "/api/v1/manage/intercity/commission/config";
      this.$confirm("确认删除这条规则吗？", "删除提示").then(async () => {
        let params = { id: row.id };
        let res = await this.$axios.delete(url, params);
        if (res && res.code === 1) {
          this.$message.success("删除成功");
          this.$refs.customTable.listFn();
        }
      });
    },

    /* 接口请求-详情 */
    async viewClick(row) {
      let url = "/api/v1/manage/intercity/commission/config/" + row.id;
      let res = await this.$axios.get(url);

      res.data.type = JSON.stringify(res.data.type);

      this.formView = res.data;
      this.formView.organizationName = row.organizationName;

      this.selects1 = JSON.parse(this.formView.commissionConfigRules);

      this.visible1 = true;
    },

    /* 点击添加阶梯规则 */
    addClicks() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let num = this.form.selects[this.form.selects.length - 1].maxFee;

          let obj = {
            minFee: num,
            maxFee: "",
            ruleType: "1",
            ruleNum: "",
            readonly: true,
            readonly1: false,
          };
          this.form.selects.push(obj);
          this.form.selects[this.form.selects.length - 2].readonly1 = true;
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },

    /* 删除提成列表 */
    deleteList() {
      this.form.selects.splice(this.form.selects.length - 1, 1);
      this.form.selects[this.form.selects.length - 1].readonly1 = false;
    },

    /* 验证器 */
    validateChangeTimeNum(rule, value, callback) {
      let arr = rule.fullField.split(".");

      let i = Number(arr[1]);

      let prevItem = i > 0 ? this.form.selects[i - 1].maxFee : null;

      value = Number(value);
      if (value <= prevItem) {
        callback(new Error("请输入正确的规则"));
      } else if (value == 0) {
        callback(new Error("不能输入0"));
      } else {
        callback();
      }
    },

    /* 验证器 */
    validateChangeTimeNums(rule, value, callback) {
      if (value <= 0) {
        callback(new Error("请输入正确的数值"));
      } else if (value > 100) {
        callback(new Error("请勿大于100"));
      } else {
        callback();
      }
    },

    /* 验证器 */
    validateChangeTimeNums1(rule, value, callback) {
      let arr = rule.fullField.split(".");
      let i = Number(arr[1]);
      let prevItem1 = this.form.selects[i].maxFee;
      value = Number(value);
      if (prevItem1) {
        if (value >= prevItem1) {
          callback(new Error("请确认区间"));
          return false;
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="less">
#commission {
  .el-dialog {
    .el-input {
      width: 50%;
      margin-right: 20px;
    }
  }

  .inner {
    font-size: 14px;
    color: #606266;

    .el-input {
      width: 60px;
    }
  }

  .add {
    margin-top: 12px;
    width: calc(100% - 2px);
    border: 1px #ebebeb dashed;
    line-height: 28px;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: @color-primary;
      color: @color-primary;
    }
  }

  .commissions {
    line-height: 28px;
    position: relative;

    .selects {
      .el-input {
        width: 110px;
      }
    }

    .commis {
      display: flex;
      margin-top: 10px;
      height: 36px;
    }

    .testlist {
      position: absolute;
      bottom: 6px;
      right: 20px;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>
